export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    delete: '删除',
    download: '下载',
    tip: '提示',
    login: '登录',
    logout: '退出登录',
    pleaseLogin: '请登录',
    success: '成功',
    fail: '失败',
    loading: '拼命加载中...',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    operationSuccess: '操作成功',
    operationFail: '操作失败',
    networkError: '网络连接失败，请检查网络',
    serverError: '服务器错误',
    requestError: '请求失败',
    resourceNotFound: '请求的资源不存在',
    configError: '请求配置错误',
    sessionExpired: '登录信息已失效，请重新登录',
    loginExpired: '登录已过期，请重新登录',
    unauthorized: '未授权，请重新登录',
    confirmDelete: '确定要删除吗？',
    deleteSuccess: '删除成功',
    deleteCancelled: '已取消删除',
    confirmLogout: '确定退出登录吗？',
    logoutSuccess: '退出登录成功',
    fileDownloadStart: '文件开始下载',
    fileDownloadFail: '下载失败，请重试',
    systemError: '系统错误',
    pleaseWait: '请稍候...',
  },
  nav: {
    home: '首页',
    doctor: '我是医生',
    patient: '我是患者',
    case: '病例库',
    personalInfo: '个人信息',
    report: '正畸报告',
    agreement: '使用协议',
    aboutUs: '关于我们',
  },
  breadcrumb: {
    home: '首页',
    personalCenter: '个人中心',
    orthodonticReport: '正畸报告',
  },
  home: {
    title: '二饼',
    doctorBtn: '我是医生',
    patientBtn: '我是患者',
    caseBtn: '病例库',
    disclaimer1: '目前本网站为公开测试阶段，报告均为AI生成仅供参考',
    disclaimer2: '实际方案需由临床医师决定，本公司不承担任何责任',
    officialAccount: '官方公众号&小程序:二饼科技',
    contactPhone: '官方联系电话：',
    contactEmail: '官方客服邮箱：',
    address: '办公地址：深圳市前海深港合作区南山街道梦海大道5188号前海深港青年梦工场北区1栋401A1',
    pleaseLoginFirst: '请先登录',
  },
  index: {
    title: '二饼',
    chinese: '中文',
    english: '英文',
  },
  patient: {
    newChat: '开启新对话',
    recent: '最近',
    threeDaysAgo: '3天前',
    thirtyDaysAgo: '30天前',
    welcome: '我是二饼，可以帮您解答正畸相关问题，请输入文字或上传图像',
    inputPlaceholder: '请在对话框中输入您的问题，您也可以上传任意口腔图片（如口内照、面相照、全景侧位片等）让二饼帮您分析',
    dragUpload: '文件拖动到此处即可上传',
    dragUploadLimit: '最多支持 10 个文件，接受图片',
    confirmDeleteHistory: '删除后，该对话将不可恢复。确认删除吗？',
    maxImageLimit: '最多只能上传10张图片',
    invalidImage: '请选择有效的图片文件',
    uploadFileFail: '上传文件失败',
    sendMessageFail: '发送消息',
    queryMessageFail: '查询消息',
    queryHistoryFail: '查询历史记录',
    queryHistoryDetailFail: '查询历史详情',
    deleteHistoryFail: '删除历史记录',
  },
  doctor: {
    title: '请提交患者的完整信息，二饼会为您自动生成正畸诊疗报告',
    chiefComplaint: '主诉',
    chiefComplaintPlaceholder: '请输入您的正畸问题',
    age: '年龄',
    agePlaceholder: '请输入您的年龄',
    gender: '性别',
    male: '男',
    female: '女',
    step1: 'step1 上传图片',
    step2: 'step2 提交资料获得治疗计划报告',
    uploadAll: '一键上传图片',
    submitReport: '提交资料获得治疗计划报告',
    uploadHint: '请上传以下十张完整图片',
    example: '示例',
    uploadPhoto: '上传照片',
    uploadXray: '上传X光',
    photoTypes: {
      smile: '微笑相',
      front: '正面相',
      side: '侧面相',
      upperTeeth: '上牙列像',
      lowerTeeth: '下牙列像',
      rightBite: '口内右侧位像',
      centerBite: '口内正位像',
      leftBite: '口内左侧位像',
      panorama: '全颌曲面断层片',
      cephalometric: '头颅侧位定位片',
    },
    maxImageLimit: '最多只能上传10张图片',
    invalidImage: '请选择有效的图片文件',
    invalidFormat: '只支持JPG、JPEG、PNG格式的图片！',
    uploadSuccess: '上传成功！',
  },
  case: {
    tabs: {
      early: '早期矫正',
      teen: '青少年矫正',
      adult: '成人矫正',
    },
    detailTitle: '病例详情',
  },
  report: {
    title: '正畸治疗报告',
    gender: '性别',
    age: '年龄',
    chiefComplaint: '主诉',
    serialNum: '编号',
    generating: '报告正在生成中...',
    generateFailed: '报告生成失败',
    downloadTypeSelect: '下载类型选择',
    pdfFormat: 'PDF格式',
    wordFormat: 'Word格式',
    confirmDelete: '确定要删除这份报告吗？删除后将无法恢复。',
    deleteSuccess: '报告删除成功',
  },
  info: {
    tabs: {
      personalInfo: '个人信息',
      changePassword: '修改密码',
      changePhone: '更换手机号',
      changeEmail: '邮箱',
      forgotPassword: '忘记密码',
    },
    account: '账号',
    phone: '手机号',
    email: '邮箱',
    registerTime: '注册时间',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    pleaseInputOldPassword: '请输入旧密码',
    pleaseInputNewPassword: '请输入新密码',
    pleaseConfirmNewPassword: '请确认新密码',
    pleaseInputCurrentPassword: '请输入当前密码',
    newPasswordSameAsOld: '新密码不能与当前密码相同',
    passwordMismatch: '两次输入的新密码不一致',
    changePasswordSuccess: '修改密码成功',
    changePasswordFail: '修改密码失败，请检查当前密码是否正确',
    password: '密码',
    pleaseInputPassword: '请输入密码',
    pleaseInputPhone: '请输入手机号',
    pleaseInputEmail: '请输入邮箱',
    pleaseInputCode: '请输入验证码',
    pleaseInputPhoneOrEmail: '请输入手机号或邮箱',
    invalidPhone: '请输入正确的手机号',
    invalidEmail: '请输入正确的邮箱',
    getCode: '获取验证码',
    retryAfter: '秒后重新获取',
    type: '类型',
    phoneOrEmail: '手机/邮箱',
    newPhone: '新手机号',
    newEmail: '新邮箱',
    verifyCode: '验证码',
    changePhoneSuccess: '手机号修改成功',
    changePhoneFail: '手机号修改失败，请检查验证码是否正确',
    changeEmailSuccess: '邮箱修改成功',
    changeEmailFail: '邮箱修改失败，请检查验证码是否正确',
    resetPasswordSuccess: '密码重置成功',
    resetPasswordFail: '密码重置失败',
  },
  maintenance: {
    title: '网站维护中',
    desc: '抱歉，网站正在进行系统升级和维护，暂时无法访问',
    desc2: '我们会尽快完成维护，恢复正常服务，感谢您的理解与耐心等待！',
  },
  app: {
    deviceTip: '设备提示',
    mobileWarning: '由于网页端格式不兼容移动端(手机、平板)使用，为了您有更好的体验，建议打开"二饼科技"微信小程序使用二饼',
    gotIt: '我知道了',
    initFailed: '应用初始化失败',
  },
  footer: {
    securityRecord: '粤公网安备44030002009159',
    icpRecord: '粤ICP备2025487643号-1',
  },
  login: {
    title: '登录',
    accountPasswordLogin: '账号密码登录',
    phoneCodeLogin: '手机号验证码登录',
    emailCodeLogin: '邮箱验证码登录',
    account: '账号',
    password: '密码',
    pleaseInputAccount: '请输入账号',
    pleaseInputPassword: '请输入密码',
    pleaseInputPhone: '请输入手机号',
    pleaseInputCorrectPhone: '请输入正确的手机号',
    pleaseInputEmail: '请输入邮箱',
    pleaseInputCorrectEmail: '请输入正确的邮箱',
    pleaseInputCode: '请输入验证码',
    getCode: '获取验证码',
    retryAfter: '秒后重新获取',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loginButton: '登录',
    register: '注册',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    loginSuccess: '登录成功',
    loginFail: '登录失败，请检查账号密码',
    registerTitle: '注册账号',
    pleaseInputPhoneOrEmail: '请输入手机号或邮箱',
    registerSuccess: '注册成功，请登录',
    registerFail: '注册失败',
    sendCodeFail: '验证码发送失败',
  },
  register: {
    title: '注册',
    account: '账号',
    phone: '手机号',
    verifyCode: '验证码',
    password: '密码',
    confirmPassword: '确认密码',
    pleaseInputAccount: '请输入账号',
    pleaseInputPhone: '请输入手机号',
    pleaseInputCode: '请输入验证码',
    pleaseInputPassword: '请输入密码',
    pleaseConfirmPassword: '请确认密码',
    pleaseInputPhoneFirst: '请先输入手机号',
    invalidPhone: '请输入正确的手机号',
    getCode: '获取验证码',
    retryAfter: '秒后重试',
    codeSent: '验证码已发送',
    codeSendFail: '验证码发送失败',
    passwordMismatch: '两次输入的密码不一致',
    registerButton: '注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    registerSuccess: '注册成功',
    registerFail: '注册失败',
  },
}
